export default __webpack_public_path__ + "static/badge_new-154cebb0fd516ca37c29dc1fec6bf79b.gif";